<script setup>
import { PrimaryButton } from '@codinglabsau/ui'
import SurnameFilterLinks from '@/Components/Convicts/SurnameFilterLinks.vue'
import PageHeader from '@/Components/PageHeader.vue'
</script>

<template>
  <PageHeader title="Convicts">
    <template #actions>
      <SurnameFilterLinks />
      <PrimaryButton :href="route('convicts.create')"> Add Convict </PrimaryButton>
    </template>
  </PageHeader>
</template>
